/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IRadiationSession } from 'app/shared/model/radiation-session.model';

export interface IOrganAtRisk {
  id?: string;
  name?: string | null;
  description?: string | null;
  code?: string | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  radiationSessions?: IRadiationSession[] | null;
}

export const defaultValue: Readonly<IOrganAtRisk> = {
  active: false,
};
